import React from 'react'

const Spinner: React.FC<any> = () => {
  return (
    <div className="sk-circle">
      <div className="sk-circle1 sk-child">&nbsp;</div>
      <div className="sk-circle2 sk-child">&nbsp;</div>
      <div className="sk-circle3 sk-child">&nbsp;</div>
      <div className="sk-circle4 sk-child">&nbsp;</div>
      <div className="sk-circle5 sk-child">&nbsp;</div>
      <div className="sk-circle6 sk-child">&nbsp;</div>
      <div className="sk-circle7 sk-child">&nbsp;</div>
      <div className="sk-circle8 sk-child">&nbsp;</div>
      <div className="sk-circle9 sk-child">&nbsp;</div>
      <div className="sk-circle10 sk-child">&nbsp;</div>
      <div className="sk-circle11 sk-child">&nbsp;</div>
      <div className="sk-circle12 sk-child">&nbsp;</div>
    </div>
  )
}

export default Spinner
